import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutModule } from '@angular/cdk/layout';

import { NgxSpinnerModule } from 'ngx-spinner'
import { AgGridModule } from 'ag-grid-angular';

import {AvatarModule} from 'primeng/avatar';
import {BadgeModule} from 'primeng/badge';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {ButtonModule} from 'primeng/button';
import {CardModule} from 'primeng/card'
import {CalendarModule} from 'primeng/calendar';
import {ChipModule} from 'primeng/chip';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {DividerModule} from 'primeng/divider';
import {DropdownModule} from 'primeng/dropdown';
import {DialogService, DynamicDialogModule} from 'primeng/dynamicdialog';
import {InputMaskModule} from 'primeng/inputmask';
import {InputNumberModule} from 'primeng/inputnumber';
import {InputTextModule} from 'primeng/inputtext';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {MenuModule} from 'primeng/menu';
import {MenubarModule } from 'primeng/menubar';
import {MessageModule} from 'primeng/message';
import {MessagesModule} from 'primeng/messages';
import {MultiSelectModule} from 'primeng/multiselect';
import {PasswordModule} from 'primeng/password';
import {ProgressBarModule} from 'primeng/progressbar';
import {PanelModule} from 'primeng/panel';
import {RippleModule} from 'primeng/ripple';
import {SidebarModule} from 'primeng/sidebar';
import {SplitterModule} from 'primeng/splitter';
import {TableModule} from 'primeng/table';
import {TabViewModule} from 'primeng/tabview';
import {ToastModule} from 'primeng/toast';
import {ToolbarModule} from 'primeng/toolbar';
import {TooltipModule} from 'primeng/tooltip';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';

import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { SigninRedirectCallbackComponent } from './authentication/signin-redirect-callback.component';
import { SignoutRedirectCallbackComponent } from './authentication/signout-redirect-callback.component';
import { HttpHeaderInterceptor } from './services/interceptors/http-header.interceptor';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './authentication/login.component';
import { UpdateRequestDateHttpInterceptor } from './services/interceptors/update-request-date.interceptor';
import { UpdateResponseDateHttpInterceptor } from './services/interceptors/update-response-date.interceptor';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ErrorComponent } from './shared/error.component';

import { ProjectModule } from './projects/project.module';
import { RosterModule } from './roster/roster.module';
import { EmployeeModule } from './employees/employee.module';
import { TimesheetModule } from './timesheet/timesheet.module';
import { AdminModule } from './admin/admin.module';
import { SystemSettingsModule } from './system-settings/system-settings.module';
import { PayrollModule } from './payroll/payroll.module';
import { ReportModule } from './reports/report.module';

@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent,
    NavMenuComponent,
    SigninRedirectCallbackComponent,
    SignoutRedirectCallbackComponent,
    HomeComponent,
    LoginComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    LayoutModule,
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule.withComponents([
    ]),
    AvatarModule,
    BadgeModule,
    ButtonModule,
    BreadcrumbModule,
    CalendarModule,
    CardModule,
    ChipModule,
    ConfirmDialogModule,
    DividerModule,
    DropdownModule,
    DynamicDialogModule,
    InputMaskModule,
    InputNumberModule,
    InputTextModule,
    InputTextareaModule,
    MenuModule,
    MenubarModule,
    MessageModule,
    MessagesModule,
    MultiSelectModule,
    PasswordModule,
    PanelModule,
    ProgressBarModule,
    RippleModule,
    SidebarModule,
    SplitterModule,
    TableModule,
    TabViewModule,
    ToastModule,
    ToolbarModule,
    TooltipModule,

    AdminModule,
    EmployeeModule,
    ProjectModule,
    RosterModule,
    TimesheetModule,
    PayrollModule,
    ReportModule,
    SystemSettingsModule
  ],
  providers: [
    ConfirmationService,
    DialogService,
    MessageService,
    {provide: HTTP_INTERCEPTORS, useClass: HttpHeaderInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: UpdateRequestDateHttpInterceptor, multi: true},    
    {provide: HTTP_INTERCEPTORS, useClass: UpdateResponseDateHttpInterceptor, multi: true}
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
